export const placeholderLabelValue = { label: '', value: '' }

// matches the format of uuid strings by grouping letters and digits in a sequence of 8-4-4-4-12
// 5ca05433-b1da-401b-886f-bb74b58cf216
export const UUID_FORMAT =
  /[a-zA-Z\d+]{8}-[a-zA-Z\d+]{4}-[a-zA-Z\d+]{4}-[a-zA-Z\d+]{4}-[a-zA-Z\d+]{12}/

export const DATE_PICKER_DISPLAY_FORMAT = 'dd LLL yyyy'
